export { TextFit }

const textFitTimeout = {}

const TextFit = (el) => {
  if (!el) throw new Error('TextFit got no element')

  if (!el.id) throw new Error('TextFit got element without and id')

  if (textFitTimeout[el.id]) clearTimeout(textFitTimeout[el.id])
  textFitTimeout[el.id] = setTimeout(() => textFit(el), 100)
}

const textFit = el => {
  if (window.location.search.match(/debugger/)) throw new Error('debugger')
  textFitTimeout[el.id] = null
  let count             = 100
  let fontSize          = 5
  el.maxFontSize        = parseInt(el.maxFontSize || '1000')
  el.style.overflow     = 'scroll'
  setFontSize(el, fontSize)
  let scrollbarX = el.offsetWidth  - el.scrollWidth  // fix for windows OS
  let scrollbarY = el.offsetHeight - el.scrollHeight // fix for windows OS
  while ((el.scrollWidth + scrollbarX) === el.offsetWidth && (el.scrollHeight + scrollbarY) === el.offsetHeight) {
    if (fontSize >= el.maxFontSize) break

    if (count-- === 0) {
      throw new Error(`bad text fit logic for element: ${el.id}`)
    }

    setFontSize(el, ++fontSize)
  }
  setFontSize(el, fontSize - 1 - (parseInt(el.fitmod || '0')))
  el.style.overflow = 'hidden'
}

const setFontSize = (el, size) => {
  el.style.fontSize = `${size}px`
}
